var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { head, round } from '../../../../../utils/helper/lodash_replacements';
import { configTrait } from '../../../../../registry/trait/ConfigTrait';
export class AspectKeyValue {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectKey() {
        return this.parent;
    }
    get aspect() {
        return this.aspectKey.aspect;
    }
    get reg() {
        return this.aspectKey.reg;
    }
    get activeAttachedTraits() {
        if (this.aspectKey.keyReduced.reductionBase.length === 0) {
            return []; // Abkürzung / Optimierung
        }
        return this.aspectKey.keyActive.activeTraits;
    }
    get activeAttachedTraitSingle() {
        return head(this.activeAttachedTraits);
    }
    get valuesMultiple() {
        return this.activeAttachedTraits.map(at => at.attachedValue);
    }
    get valueSingle() {
        if (this.activeAttachedTraitSingle && typeof this.activeAttachedTraitSingle.attachedValue !== 'undefined') {
            return this.activeAttachedTraitSingle.attachedValue;
        }
        return undefined;
    }
    get valuesMultipleWithDefaultFallback() {
        if (this.valuesMultiple.length > 0) {
            return this.valuesMultiple;
        }
        if (this.reg.default) {
            return [this.reg.default];
        }
        return [];
    }
    get valueSingleWithDefaultFallback() {
        if (typeof this.valueSingle !== 'undefined') {
            return this.valueSingle;
        }
        if (!this.reg) {
            console.error(`trait reg item ${this.aspectKey.traitKey} is not available in`, this.aspect.readableIdentifier);
            return undefined;
        }
        return this.reg.default;
    }
    /* LOCAL */
    get scaledValueSingleWithDefaultFallback() {
        if (!configTrait.scaleProperties.includes(this.aspectKey.traitKey))
            return this.valueSingleWithDefaultFallback;
        if (this.activeAttachedTraitSingle && typeof this.activeAttachedTraitSingle.scaledValue !== 'undefined') {
            return this.activeAttachedTraitSingle.scaledValue;
        }
        const scaleSetting = this.aspect.context.stage.ownAspect.scaling.valueOf[`scale_${this.aspectKey.traitKey}`];
        let scaledValue = this.reg.default;
        if (scaleSetting === 'width') {
            scaledValue = this.reg.default * this.aspect.context.stage.stageInnerMeasure.stageWidthRatio;
        }
        if (scaleSetting === 'height') {
            scaledValue = this.reg.default * this.aspect.context.stage.stageInnerMeasure.stageHeightRatio;
        }
        if (scaleSetting === 'ratio') {
            scaledValue = this.reg.default * this.aspect.context.stage.stageInnerMeasure.stageDiagonalRatio;
        }
        const reg = this.reg;
        if (typeof reg.roundDecimals !== 'undefined')
            scaledValue = round(scaledValue, reg.roundDecimals);
        return scaledValue;
    }
}
__decorate([
    computed
], AspectKeyValue.prototype, "activeAttachedTraitSingle", null);
__decorate([
    computed
], AspectKeyValue.prototype, "scaledValueSingleWithDefaultFallback", null);
